import { render, staticRenderFns } from "./LayoutVazio.vue?vue&type=template&id=4068a6d7&"
import script from "./LayoutVazio.vue?vue&type=script&lang=js&"
export * from "./LayoutVazio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports